import { action } from 'sky-engine/api/index'

import { FEATURE_MNG } from '@/api/apiModules'
/**
 * 获取功能的版本详情信息
 * @param {*} data
 * @returns
 */
export function getFeatureDetail(data) {
  return action(FEATURE_MNG, '/detail', data)
}
